<template>
  <div class="case-detail">
    <!-- 导航栏 -->
    <Navbar :entName="entName" :logo="logo" />

    <!-- 页面内容 -->
    <section class="case-content">
      <div class="container">
        <div class="breadcrumb">
          <router-link to="/">首页</router-link>
          <span>/</span>
          <router-link to="/cases">成功案例</router-link>
          <span>/</span>
          <span class="current">{{ caseItem.title || "案例详情" }}</span>
        </div>
        <h1>{{ caseItem.title || "案例详情" }}</h1>
        <div v-if="caseItem.contentAll" v-html="caseItem.contentAll"></div>
        <div v-else>
          <p>加载中...</p>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <Footer v-bind="footerData" />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import api from "@/api";
import { pageDataMixin } from "@/mixins/pageData";

export default {
  name: "CaseDetail",
  components: {
    Navbar,
    Footer,
  },
  mixins: [pageDataMixin],
  data() {
    return {
      caseItem: {
        title: "",
        contentAll: ""
      }
    };
  },
  mounted() {
    this.fetchCaseDetail();
  },
  methods: {
    fetchCaseDetail() {
      const caseId = this.$route.query.id;
      if (caseId) {
        // 这里应该调用获取单个案例详情的接口
        // 由于接口地址未提供，暂时使用获取案例列表的接口，然后根据ID过滤
        api.get("/api/case/getCaseList")
          .then(response => {
            if (response.data.code === 0) {
              const caseItem = response.data.data.find(c => c.id == caseId);
              if (caseItem) {
                this.caseItem = caseItem;
              }
            }
          })
          .catch(() => {
            // 静默处理错误
          });
      }
    }
  }
};
</script>

<style scoped>
.case-detail {
  font-family: Arial, sans-serif;
}

/* 通用样式 */
.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}

/* 案例详情 */
.case-content {
  padding: 4rem 0;
}

.breadcrumb {
  margin-bottom: 2rem;
  font-size: 0.9rem;
  color: #666;
}

.breadcrumb a {
  color: #007bff;
  text-decoration: none;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

.breadcrumb span {
  margin: 0 0.5rem;
}

.breadcrumb .current {
  color: #333;
  font-weight: bold;
}

.case-content h1 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  color: #333;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .case-content h1 {
    font-size: 2rem;
  }
}
</style>